import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-arrow-two",
  "use": "app-icon-arrow-two-usage",
  "viewBox": "0 0 267 210",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 267 210\" id=\"app-icon-arrow-two\"><path d=\"M146 5v35h-1V4h112.5V0l9 4.5-9 4.5V5H146zm-1 96.5V72h1v70h-1v-39.5H.5v-1H145zm1 72.5v36h-1v-36h1z\" fill=\"#B8BECC\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol